import RestrictedRegistry from '../../../components/RestrictedRegistry';
import React, { useEffect, useState } from 'react';
import EventsFilter from './eventsFilter';
import PageTitle from '../../../components/PageTitle';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FeatherIcon from 'react-feather';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Input, Row } from 'reactstrap';
import PreloaderWidget from '../../../components/Loader';
import { delete_incubation, list_incubation } from '../../../helpers/actions/api.functions';
import Swal from 'sweetalert2';

const IncubationApplicationList = () => {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [flag, setFlag] = useState(false);
  const [modal, setModal] = useState(false);

 const getIncubatees = () => {
  setIsActive(true);
  list_incubation()
    .then((res) => {
      setIsActive(false);

      // Log response to ensure structure
      console.log("API Response:", res);

      const taskList = res?.data;

      if (Array.isArray(taskList)) {
        setData(taskList);
      } else {
        toast.error("Invalid data received.");
        console.error("Expected tasks_list array but got:", res);
        setData([]);
      }

      setFlag(false);
    })
    .catch((err) => {
      setIsActive(false);
      toast.error(err?.response?.data?.message || "Failed to fetch incubation list.");
    });
};

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        delete_incubation(id)
          .then((res) => {
            setIsActive(false);
            toast.success(res.message);
            getIncubatees();
          })
          .catch((err) => {
            setIsActive(false);
            toast.error(err?.response?.data?.message || "Failed to delete item.");
          });
      }
    });
  };

  const columns = [
        {
            dataField: 'user.restricted_registry',
            text: 'Restricted Registry',
            formatter: (cell, row) => <RestrictedRegistry user={row.user} compact />,
            csvExport: false,
        },
    { dataField: 'startup_name', text: 'Startup/Company name', sort: true },
    { dataField: 'legal_entity_type', text: 'Legal entity type', sort: true },
    {
      dataField: 'registration_date',
      text: 'Date of registration/incorporation',
      sort: true,
      formatter: (cell) => {
      if (!cell) return "";
      const date = new Date(cell);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
      }
    },
    { dataField: 'website', text: 'Website', sort: false },
    { dataField: 'contact_name', text: 'Full name', sort: false },
    { dataField: 'contact_designation', text: 'Designation', sort: false },
    { dataField: 'contact_email', text: 'Email address', sort: false },
    { dataField: 'contact_phone', text: 'Phone number', sort: false },
    // { dataField: 'address_street', text: 'Street address', sort: false },
    // { dataField: 'address_city', text: 'City', sort: false },
    // { dataField: 'address_state', text: 'State/Province', sort: false },
    // { dataField: 'address_zip', text: 'PIN/Zip Code', sort: false },
    // { dataField: 'address_country', text: 'Country', sort: false },
    // { dataField: 'industry_sector', text: 'Sector/Industry', sort: false },
    // { dataField: 'startup_stage', text: 'Startup Stage', sort: false },
    // { dataField: 'business_description', text: 'Brief Description of your Startup/Business Idea', sort: false },
    // { dataField: 'annual_turnover', text: 'Annual Turnover', sort: false },
    // { dataField: 'problem_statement', text: 'Problem Statement', sort: false },
    // { dataField: 'solution', text: 'Solution', sort: false },
    // { dataField: 'unique_value_proposition', text: 'Unique Value Proposition', sort: false },
    // { dataField: 'target_market', text: 'Target Market', sort: false },
    // { dataField: 'revenue_model', text: 'Revenue Model', sort: false },
    // { dataField: 'service_interest', text: 'Service Interest', sort: false },
    // { dataField: 'resources_needed', text: 'Resources Needed', sort: false },
    // { dataField: 'key_milestones', text: 'Key Milestones', sort: false },
    // { dataField: 'previous_programs', text: 'Previous Programs', sort: false },
    // { dataField: 'declaration_agreed', text: 'Declaration', sort: false },
    // { dataField: 'signature', text: 'Signature', sort: false },
    {
      dataField: 'id',
      text: 'Action',
      sort: false,
      formatter: (rowContent, row) => (
        <div className="d-flex">
          <div className="mr-2">
            <Link to={`/incubation-detail/${rowContent}`}>
              <FeatherIcon.Eye className="icon-action view-ico" />
            </Link>
          </div>
          <div onClick={() => handleDelete(rowContent)}>
            <FeatherIcon.Trash className="icon-action delete-ico" />
          </div>
        </div>
      ),
    },
  ];

  const defaultSorted = [{ dataField: 'id', order: 'desc' }];

  const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
    <>
      <label className="d-inline mr-1">Show</label>
      <Input
        type="select"
        name="select"
        id="no-entries"
        className="custom-select custom-select-sm d-inline col-1 pl-1"
        defaultValue={currSizePerPage}
        onChange={(e) => onSizePerPageChange(e.target.value)}
      >
        {options.map((option, idx) => (
          <option key={idx} value={option.page}>{option.text}</option>
        ))}
      </Input>
      <label className="d-inline ml-1">entries</label>
    </>
  );

  const { SearchBar } = Search;

  useEffect(() => {
    getIncubatees();
  }, []);

  if (isActive) {
    return <PreloaderWidget />;
  }

  return (
    <React.Fragment>
      <Row className="page-title">
        <Col md={12}>
          <PageTitle
            breadCrumbItems={[{ label: 'Incubation Applications', path: '/incubation-application-list', active: true }]}
            title={'Incubation Applications'}
          />
        </Col>
      </Row>
      <Row>
        <Card>
          <CardBody>
            <ToolkitProvider
              bootstrap4
              keyField="id"
              data={data}
              columns={columns}
              search
              exportCSV={{ onlyExportFiltered: true, exportAll: false }}
            >
              {(props) => (
                <>
                  <BootstrapTable
                    {...props.baseProps}
                    bordered={true}
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory({
                      sizePerPage: 5,
                      sizePerPageRenderer: sizePerPageRenderer,
                      sizePerPageList: [
                        { text: '5', value: 5 },
                        { text: '10', value: 10 },
                        { text: '25', value: 25 },
                        { text: 'All', value: data.length },
                      ],
                    })}
                    wrapperClasses="table-responsive"
                  />
                </>
              )}
            </ToolkitProvider>
          </CardBody>
        </Card>
      </Row>

      {modal && <EventsFilter open={modal} handleClose={() => setModal(false)} handleApply={() => setModal(false)} />}
    </React.Fragment>
  );
};

export default IncubationApplicationList;
